import { useNavigate } from "react-router-dom";
import { useV1FormsFormInstancesList } from "@/api/generated/v1/v1";
import { PageBanner } from "@/shared/components/PageBanner";

export function FormInstanceListPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useV1FormsFormInstancesList({ page: 1 } as any);

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="آرشیو فرم‌های ثبت‌شده"
        subtitle="مشاهده و پیگیری فرم‌های پر شده در سیستم"
        icon="🗂️"
        helpLink="/help/forms/instances"
      >
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          <button
            onClick={() => navigate("/forms")}
            style={{
              padding: "0.6rem 1rem",
              borderRadius: "12px",
              background: "rgba(255, 255, 255, 0.15)",
              color: "#ffffff",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              fontWeight: 700,
              fontSize: "0.85rem",
              cursor: "pointer",
            }}
          >
            ← بازگشت
          </button>
        </div>
      </PageBanner>

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>

        {isLoading && <p style={{ color: "var(--color-text-muted)" }}>در حال بارگذاری...</p>}

        {!isLoading && (
          <div className="table-container" style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", textAlign: "right", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid var(--glass-border)" }}>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>تاریخ ثبت</th>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>وضعیت</th>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {(data?.results || []).length === 0 ? (
                  <tr>
                    <td colSpan={3} style={{ padding: "2rem", textAlign: "center", color: "var(--color-text-muted)" }}>
                      هیچ فرمی ثبت نشده.
                    </td>
                  </tr>
                ) : (
                  data!.results.map((inst: any) => (
                    <tr key={inst.id} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                      <td style={{ padding: "1rem" }} dir="ltr" className="text-left">
                        {new Date(inst.submitted_at).toLocaleString("fa-IR")}
                      </td>
                      <td style={{ padding: "1rem" }}>
                        {inst.corrected_instance ? (
                          <span style={{ color: "var(--color-gold)" }}>اصلاحیه</span>
                        ) : (
                          <span style={{ color: "var(--color-success)" }}>اصلی</span>
                        )}
                      </td>
                      <td style={{ padding: "1rem" }}>
                        <button
                          className="btn btn-secondary"
                          style={{ fontSize: "0.85rem", padding: "0.3rem 0.75rem" }}
                          onClick={() => navigate(`/forms/instances/${inst.id}`)}
                        >
                          مشاهده
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
